export default __webpack_public_path__ + "i18n/translation-ml.cca93de4.json";